import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ServiceOrderFilters = ({ filters, onFiltersChange, onClearFilters }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const statusOptions = [
    { value: '', label: 'Todos os Status' },
    { value: 'Pendente', label: 'Pendente' },
    { value: 'Em Andamento', label: 'Em Andamento' },
    { value: 'Concluído', label: 'Concluído' },
    { value: 'Cancelado', label: 'Cancelado' }
  ];

  const priorityOptions = [
    { value: '', label: 'Todas as Prioridades' },
    { value: 'Alta', label: 'Alta' },
    { value: 'Média', label: 'Média' },
    { value: 'Baixa', label: 'Baixa' }
  ];

  const technicianOptions = [
    { value: '', label: 'Todos os Técnicos' },
    { value: 'joao-silva', label: 'João Silva' },
    { value: 'maria-santos', label: 'Maria Santos' },
    { value: 'carlos-oliveira', label: 'Carlos Oliveira' },
    { value: 'ana-costa', label: 'Ana Costa' }
  ];

  const serviceTypeOptions = [
    { value: '', label: 'Todos os Tipos' },
    { value: 'Manutenção Preventiva', label: 'Manutenção Preventiva' },
    { value: 'Manutenção Corretiva', label: 'Manutenção Corretiva' },
    { value: 'Instalação', label: 'Instalação' },
    { value: 'Consultoria', label: 'Consultoria' },
    { value: 'Suporte Técnico', label: 'Suporte Técnico' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  const getActiveFiltersCount = () => {
    return Object.values(filters)?.filter(value => value && value !== '')?.length;
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-professional mb-6">
      {/* Filter Header */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center space-x-3">
          <Icon name="Filter" size={20} className="text-muted-foreground" />
          <h3 className="font-medium text-card-foreground">Filtros</h3>
          {getActiveFiltersCount() > 0 && (
            <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full">
              {getActiveFiltersCount()} ativo{getActiveFiltersCount() > 1 ? 's' : ''}
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          {getActiveFiltersCount() > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
            >
              Limpar
            </Button>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsExpanded(!isExpanded)}
            className="lg:hidden"
          >
            <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={20} />
          </Button>
        </div>
      </div>
      {/* Filter Content */}
      <div className={`${isExpanded ? 'block' : 'hidden'} lg:block`}>
        <div className="p-4 space-y-4">
          {/* Search */}
          <div className="w-full">
            <Input
              type="search"
              placeholder="Buscar por número da OS, cliente ou descrição..."
              value={filters?.search || ''}
              onChange={(e) => handleFilterChange('search', e?.target?.value)}
              className="w-full"
            />
          </div>

          {/* Filter Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Status Filter */}
            <Select
              label="Status"
              options={statusOptions}
              value={filters?.status || ''}
              onChange={(value) => handleFilterChange('status', value)}
            />

            {/* Priority Filter */}
            <Select
              label="Prioridade"
              options={priorityOptions}
              value={filters?.priority || ''}
              onChange={(value) => handleFilterChange('priority', value)}
            />

            {/* Technician Filter */}
            <Select
              label="Técnico"
              options={technicianOptions}
              value={filters?.technician || ''}
              onChange={(value) => handleFilterChange('technician', value)}
              searchable
            />

            {/* Service Type Filter */}
            <Select
              label="Tipo de Serviço"
              options={serviceTypeOptions}
              value={filters?.serviceType || ''}
              onChange={(value) => handleFilterChange('serviceType', value)}
              searchable
            />
          </div>

          {/* Date Range */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input
              type="date"
              label="Data Inicial"
              value={filters?.startDate || ''}
              onChange={(e) => handleFilterChange('startDate', e?.target?.value)}
            />
            <Input
              type="date"
              label="Data Final"
              value={filters?.endDate || ''}
              onChange={(e) => handleFilterChange('endDate', e?.target?.value)}
            />
          </div>

          {/* Quick Filters */}
          <div className="flex flex-wrap gap-2 pt-2 border-t border-border">
            <span className="text-sm text-muted-foreground mr-2">Filtros rápidos:</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleFilterChange('status', 'Pendente')}
              className={filters?.status === 'Pendente' ? 'bg-warning/10 text-warning' : ''}
            >
              Pendentes
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleFilterChange('status', 'Em Andamento')}
              className={filters?.status === 'Em Andamento' ? 'bg-primary/10 text-primary' : ''}
            >
              Em Andamento
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleFilterChange('priority', 'Alta')}
              className={filters?.priority === 'Alta' ? 'bg-error/10 text-error' : ''}
            >
              Alta Prioridade
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                const today = new Date()?.toISOString()?.split('T')?.[0];
                handleFilterChange('startDate', today);
                handleFilterChange('endDate', today);
              }}
              className={filters?.startDate === new Date()?.toISOString()?.split('T')?.[0] ? 'bg-success/10 text-success' : ''}
            >
              Hoje
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceOrderFilters;